export var base = {
  color: '#666666',
  colors: {},
  size: {
    small: '12px',
    medium: '24px',
    large: '48px',
    xlarge: '96px'
  }
};